import axios, { AxiosError } from 'axios';
import { useAuthStore } from '@/store/authStore';

// Vite dev usa proxy (vite.config.ts). En prod la app es servida por el mismo dominio
// que el backend (split por path en Nginx ingress), así que rutas relativas /api/ funcionan.
export const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

// Inyecta JWT en cada request
apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Si el backend devuelve 401, deslogueamos
apiClient.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401 && useAuthStore.getState().token) {
      useAuthStore.getState().logout();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);
